"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var memoize_one_1 = __importDefault(require("@stoplight/memoize-one"));

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var baseProps_1 = __importStar(require("../assets/baseProps"));

var mobileStylesHelper_1 = require("../assets/mobileStylesHelper");

var withResponsive_1 = require("../decorators/withResponsive");

var withStyles_1 = require("../decorators/withStyles");

var Input_1 = __importDefault(require("../Input/Input"));

var Text_1 = __importDefault(require("../Text/Text"));

var isUndoRedo_1 = require("../utils/isUndoRedo");

var SplitInput_styles_1 = require("./SplitInput.styles");

var UNICODE_BLACK_CIRCLE = "\u25CF";
var EMPTY_INPUT_SYMBOL = ' ';
var BACKSPACE_KEY_CODE = 8;
var ARROW_UP_KEY_CODE = 38;
var ARROW_DOWN_KEY_CODE = 40;

var SplitInput =
/** @class */
function (_super) {
  __extends(SplitInput, _super);

  function SplitInput(props) {
    var _this = _super.call(this, props) || this; // массив инпутов для ввода цифр телефона


    _this.inputs = [];

    _this.getInputRef = function (i) {
      return function (ref) {
        /* istanbul ignore next line */
        if (ref) {
          _this.inputs[i] = ref;
        }
      };
    };
    /**
     * Получить индекс инпута
     * @param input
     */


    _this.getInputIndex = function (input) {
      var index;

      _this.inputs.every(function (inp, i) {
        if (inp === input) {
          index = i;
          return false;
        }

        return true;
      });

      return index;
    };

    _this.getOnKeyDownHandler = function (i) {
      return function (evt) {
        var stateValue = _this.state.value;
        var propsValue = _this.props.value;
        var value = propsValue || stateValue;

        if (isUndoRedo_1.isUndo(evt) || isUndoRedo_1.isRedo(evt)) {
          evt.preventDefault();
        } // запрещаем уменьшать/увеличивать значение в инпуте стрелочками вниз/вверх


        if (evt.keyCode === ARROW_UP_KEY_CODE || evt.keyCode === ARROW_DOWN_KEY_CODE) {
          evt.preventDefault();
        } // при нажатии на backspace в пустом инпуте ставим фокус на предыдущий инпут


        var isEmptyInput = !value[i] || !value[i].replace(EMPTY_INPUT_SYMBOL, '');

        if (evt.keyCode === BACKSPACE_KEY_CODE && isEmptyInput) {
          var prevInp = _this.inputs[i - 1];

          if (prevInp) {
            prevInp.focus();
            evt.preventDefault();
          }
        }
      };
    }; // eslint-disable-next-line sonarjs/cognitive-complexity


    _this.onInput = function (evt) {
      var target = evt.target;
      var stateValue = _this.state.value;
      var _a = _this.props,
          propsValue = _a.value,
          onChange = _a.onChange;
      var value = propsValue || stateValue;

      var index = _this.getInputIndex(target); // индекс измененного инпута
      // фикс IE11 с бесконечным вызовом onInput при установки фокуса в инпут с плейсхолдером
      // проверяем, было ли изменено значение в инпуте, или же был просто поставлен фокус


      var oldValue = value[index].replace(/\s/, '');
      var wasTargetInputValueChanged = target.value !== oldValue;

      if (!target.value && !wasTargetInputValueChanged) {
        // в инпут type=number можно ввести символ "e", ".", "," - удаляем их
        target.value = null;
        evt.preventDefault();
        return;
      }

      var inputsLength = _this.inputs.length; // Случай, когда в инпут вводится вторая цифра или вставляется ряд цифр.
      // В инпуте должно остаться только нововведенное значение. Текущее - удаляем. Нужно при вставке, когда
      // неизвестно, где фокус - перед или после цифры в инпуте, а также для последнего инпута, чтобы при вводе
      // второй цифры значение не перезаписывалось.

      var newValueLength = target.value.length;
      var currentValue = value[index];

      if (currentValue.trim() && newValueLength > 1) {
        // Для последнего инпута однозначно оставляем только первый символ
        if (index === inputsLength - 1) {
          target.value = target.value[0];
        } // Для других инпутов проверяем, вставили значение до значения в инпуте или после, и удаляем текущее
        // значение


        if (index !== inputsLength - 1) {
          switch (currentValue) {
            case target.value[newValueLength - 1]:
              target.value = target.value.slice(0, newValueLength - 1);
              break;

            case target.value[0]:
              target.value = target.value.slice(1);
              break;
          }
        }
      } // Вычисляем индекс инпута, в который мы должны переставить фокус (учитываем, что при вставке, к примеру,
      // 4 цифр, мы должны переставить фокус на 4 инпута вперед, или, если инпутов не хватает - то в последний


      var nextFocusInputIndex = index + target.value.length;
      nextFocusInputIndex = nextFocusInputIndex < inputsLength ? nextFocusInputIndex : inputsLength - 1; // получаем новое текущее значение (учитываем, что в один инпут могли вставить целую строку)

      var newValue = [];

      for (var i = 0; newValue.length < inputsLength;) {
        var inputValue = _this.inputs[i].value || EMPTY_INPUT_SYMBOL;
        newValue = newValue.concat(inputValue.split(''));
        i += inputValue.length;
      } // ограничиваем значение количеством инпутов


      newValue = newValue.slice(0, inputsLength); // в инпут type=number можно ввести символ "e", ".", "," - удаляем их

      target.value = null;

      _this.setState({
        value: newValue
      }, function () {
        _this.inputs[nextFocusInputIndex].focus();
      }); // если передали обработчик, прокидываем текущее значение наверх


      if (onChange) {
        onChange(newValue.join(''));
      }
    }; // используем onInput, но реакт требует передачи onChange

    /* istanbul ignore next line */


    _this.onChange = baseProps_1.noop;
    _this.getFormattedMask = memoize_one_1.default(function (mask, prefix) {
      // если передан префикс, модифицируем маску: '+P(PPP)PII...' -> '+7(987)6II...'
      if (prefix) {
        var i_1 = 0;
        return mask.replace(/P/g, function () {
          return prefix[i_1++];
        });
      }

      return mask;
    });
    _this.getInputsHandlers = memoize_one_1.default(function (mask) {
      var handlers = [];
      mask.split('').forEach(function (_, i) {
        handlers.push({
          ref: _this.getInputRef(i),
          onKeyDown: _this.getOnKeyDownHandler(i)
        });
      });
      return handlers;
    }); // количество инпутов, которое будет отрисовано

    var inputsCount = (props.mask.match(/I/g) || []).length;
    _this.state = {
      value: new Array(inputsCount).fill(EMPTY_INPUT_SYMBOL)
    };
    return _this;
  }

  Object.defineProperty(SplitInput.prototype, "innerBlocks", {
    get: function get() {
      var _a;

      var _this = this;

      var _b = this.props,
          classes = _b.classes,
          mask = _b.mask,
          prefix = _b.prefix,
          autoFocus = _b.autoFocus,
          overflowHidden = _b.overflowHidden,
          placeholder = _b.placeholder,
          invalid = _b.invalid,
          testId = _b.testId,
          propsValue = _b.value;
      var stateValue = this.state.value;
      var value = propsValue || stateValue;
      var formattedMask = this.getFormattedMask(mask, prefix);
      var inputsHandlers = this.getInputsHandlers(mask);
      var inputIndex = 0;
      var wrapperClassName = classnames_1.default(classes.wrapper, (_a = {}, _a[classes.leftHiddenWrapper] = overflowHidden === 'left', _a));
      return react_1.default.createElement("div", {
        className: wrapperClassName
      }, formattedMask.split('').map(function (c, k) {
        switch (true) {
          case c === 'I':
            {
              var isFirstInput = inputIndex === 0;
              var handlers = inputsHandlers[inputIndex];
              var val = value[inputIndex];
              inputIndex++;
              return react_1.default.createElement("div", {
                key: k,
                className: classes.input
              }, react_1.default.createElement(Input_1.default, {
                testId: testId ? testId + "__input_" + k : null,
                inputRef: handlers.ref,
                autoFocus: autoFocus && isFirstInput,
                type: "number",
                pattern: "\\d*",
                placeholder: placeholder,
                invalid: invalid,
                onKeyDown: handlers.onKeyDown,
                onInput: _this.onInput,
                onChange: _this.onChange,
                value: val && val.replace(/\D/, '')
              }));
            }

          case /[X*\d]/.test(c):
            return react_1.default.createElement("div", {
              key: k,
              className: classes.digit
            }, react_1.default.createElement(Text_1.default, null, c.replace('*', UNICODE_BLACK_CIRCLE)));

          default:
            return react_1.default.createElement(Text_1.default, {
              key: k
            }, c);
        }
      }));
    },
    enumerable: false,
    configurable: true
  });

  SplitInput.prototype.render = function () {
    var _a, _b;

    var props = this.props;
    var fade = props.fade,
        mobileFade = props.mobileFade,
        icon = props.icon,
        overflowHidden = props.overflowHidden,
        classes = props.classes;
    var containerClassName = classnames_1.default(classes.container, (_a = {}, _a[classes.blockContainer] = overflowHidden === 'right', _a), mobileStylesHelper_1.createMobileClasses(this.props));
    var hasFade = fade || mobileFade;
    var fadeClassName = classnames_1.default((_b = {}, _b[classes.fade] = hasFade, _b[classes.mobileFade] = mobileFade, _b[classes.leftFade] = (fade || mobileFade) && (overflowHidden === 'left' || !overflowHidden), _b[classes.rightFade] = (fade || mobileFade) && overflowHidden === 'right', _b), mobileStylesHelper_1.createMobileClasses(this.props));
    return react_1.default.createElement("div", __assign({}, baseProps_1.default(this.props), {
      className: containerClassName
    }), hasFade && react_1.default.createElement("div", {
      className: fadeClassName
    }), icon && react_1.default.createElement("div", {
      className: classes.icon
    }, icon), this.innerBlocks);
  };

  SplitInput = __decorate([withResponsive_1.withResponsive, withStyles_1.withStyles(SplitInput_styles_1.styles)], SplitInput);
  return SplitInput;
}(react_1.default.PureComponent);

exports.default = SplitInput;